import React, { Component } from "react";
import HotkeyHelperPanel from "./panel";
import { HotKeys, Modal, Tooltip, Icon } from "@platform/base";
import { getMultiLang } from '@platform/api';

require("./index.less");

/**
 * @namespace HotkeyHelper
 */

/**
 * HotkeyHelper快捷键帮助组件的参数描述
 * @memberof HotkeyHelper
 * @component HotkeyHelper
 * @property {array<object>} data - 事件key集合，例如：[{ area: "表格区",name: "Ctrl+A", desc: "xxx快捷操作"},{ area: "表单区",name: "Ctrl+Z",desc: "xxx快捷操作" },{area: "XXX",name: "Ctrl+X", desc: "xxx快捷操作"}]
 * @property {boolean} [enabled=true] - 是否启用
 */
class HotkeyHelper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            langJson: {},
        };
    }

    componentWillMount() {
        let callback = (langJson, bool) => {
            if (bool) {
                this.setState({ langJson });
            }
        };
        getMultiLang({ moduleId: "hotkey_helper", callback });
    }

    static defaultProps = {
        className: "",
        mask: true,
        enabled: true,
    };

    hideHandle() {
        // TODO  关闭时  聚焦回原来的元素位置
        this.setState({ show: false });
    }

    render() {
        let { langJson } = this.state;
        let {
            size,
            className,
            mask,
            indexInfo,
            enabled,
            data,
            panelType,
            ...others
        } = this.props;
        let overlay = (
            <div className="hkq-helper-content">{langJson["hk-0003"]}</div>
        );
        return enabled ? (
            <div className="hkq-helper-wrapper">
                <HotKeys
                    display={"inline-block"}
                    keyMap={{ open: ["f3"] }}
                    handlers={{
                        open: () => {
                            this.setState({ show: true });
                        },
                    }}
                    focused={true}
                />
                <Tooltip
                    placement="left"
                    inverse
                    overlay={overlay}
                    trigger={["focus", "hover"]}
                    className="hkq-helper-overlay"
                >
                    <i className="hkq-helper-btn" />
                </Tooltip>
                <Modal
                    ref={Modal => (this.Modal = Modal)}
                    visible={this.state.show}
                    onCancel={this.hideHandle.bind(this)}
                    size={size}
                    className={"combine  hkq-helper-modal  " + className}
                    mask={mask}
                    indexInfo={indexInfo}
                    {...others}
                    fieldid = "hkq-helper"
                >
                    <Modal.Header clsPrefix='wui-modal-header' closeButton={true}>
                        <span className="hkq-helper-title">
                            {langJson["hk-0001"]}
                        </span>
                        <span className="hkq-helper-toast">
                            {langJson["hk-0002"]}
                        </span>
                        <i
                            className="hkq-helper-esc"
                            onClick={this.hideHandle.bind(this)}
                        >
                            <Icon type="uf-close" />
                            &nbsp;(esc)
                        </i>
                    </Modal.Header>
                    <Modal.Body clsPrefix='wui-modal-body'>
                        <HotkeyHelperPanel
                            data={data}
                            panelType={panelType}
                            langJson = {langJson}
                            {...others}
                        />
                    </Modal.Body>
                </Modal>
            </div>
        ) : null;
    }
}

export default HotkeyHelper;
